<div class="help-layout">
  <aside class="help-layout__menu">
    <goab-link
      class="help-layout__back-link"
      size="small"
      mt="none"
      mb="none"
      data-testid="return-to-overview-link"
    >
      <a [routerLink]="['/view-entries']">
        <goab-icon type="arrow-back" size="small"></goab-icon>
        Return to Capacity reports overview
      </a>
    </goab-link>
    <goab-side-menu>
      @for (item of menuItems; track item.id) {
      <a
        [routerLink]="[item.id]"
        [routerLinkActiveOptions]="{ exact: true }"
        routerLinkActive
        #routeLink="routerLinkActive"
        [style.--goa-color-text-secondary]="routeLink.isActive ? 'var(--goa-color-text-default)' : null"
        [attr.data-testid]="'help-side-menu-item-' + item.id"
        [attr.aria-current]="routeLink.isActive ? 'page' : null"
        >{{ item.label }}</a
      >
      }
    </goab-side-menu>
  </aside>
  <section class="help-layout__content">
    <router-outlet></router-outlet>
  </section>
</div>
